import { useCallback, useState } from 'react';
import { CustomFilterProps, useGridFilter } from 'ag-grid-react';
import { Box, Button, Checkbox, FormControlLabel, FormGroup } from '@mui/material';
import { IDoesFilterPassParams } from 'ag-grid-community';

export const ArrayFilter = ({ model, onModelChange, getValue, ...params }: CustomFilterProps<any, any, unknown[]>) => {
  const { values }: { values?: string[] } = params.colDef.filterParams;
  const [filters, setFilters] = useState<string[]>([]);

  const doesFilterPass = useCallback(
    ({ node }: IDoesFilterPassParams) => {
      if (model && model.length === 0) {
        return true;
      }

      const value = getValue(node);
      return Array.isArray(value) ? value.some((v) => model?.includes(v)) : model?.includes(value) ?? false;
    },
    [model],
  );

  useGridFilter({ doesFilterPass });

  return (
    <Box sx={{ p: 2 }}>
      <FormGroup>
        {(values ?? []).map((value) => (
          <FormControlLabel
            key={value}
            control={<Checkbox checked={filters.includes(value)} />}
            label={value}
            onChange={(_event, checked) => {
              setFilters(checked ? [...filters, value] : filters.filter((f) => f !== value));
            }}
          />
        ))}
      </FormGroup>
      <Button onClick={() => onModelChange(filters)}>Apply</Button>
    </Box>
  );
};
